import AssetThree from './AssetThree';

export default AssetThree;
